import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from "@components/button/Button";
import { useWindow } from "@hooks/useWindow";
import cn from "classnames";
import { useCallback } from "react";
const SideBoxNavigation = (props) => {
    const { title, links, sideboxClassname = true } = props;
    const myWindow = useWindow();
    const isLinkActive = useCallback((link) => {
        var _a;
        return !!myWindow && ((_a = myWindow === null || myWindow === void 0 ? void 0 : myWindow.location) === null || _a === void 0 ? void 0 : _a.pathname) === link;
    }, [myWindow]);
    return (_jsxs("div", { className: cn("sidebox-navigation", sideboxClassname), children: [title && _jsx("h3", { className: "sidebox-navigation-title", children: title }), links && links.length !== 0 && (_jsx("nav", { children: _jsx("ul", { className: "sidebox-navigation-links", children: links.map(({ title: btnTitle, url, target }) => (_jsx("li", { className: cn("sidebox-navigation-links__item", { "sidebox-navigation-links__item--active": isLinkActive(url) }), children: _jsx(Button, { isActive: isLinkActive(url), link: url, title: btnTitle, target: target, type: "tertiary", className: "normal-case" }) }, title + url))) }) }))] }));
};
export default SideBoxNavigation;
